export default {
      id: "ic-tv-circle-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic-tv-circle-usage",
      toString: function () {
        return this.url;
      }
    }